import { CatalogFeaturedLotsInfo, SuggestedFeaturedLot } from '@/redux/modules/featuredLots/featuredLots.types';
import { handleResponse, makeGet, makePost } from '@/redux/api/helpers';

type GetFeaturedLotsByCatalogIdParams = {
    authToken: string;
    catalogId: number;
    deployment: string;
};

export type GetFeaturedLotsByCatalogIdResponse = {
    error: false;
    payload: CatalogFeaturedLotsInfo;
};

export const getFeaturedLotsByCatalogId = ({ authToken, catalogId, deployment }: GetFeaturedLotsByCatalogIdParams) =>
    new Promise<GetFeaturedLotsByCatalogIdResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `featured-lots/${catalogId}`,
            authToken,
            deployment,
            path: '<PROMOTIONS-API>',
        });
        request.end((err, response) =>
            handleResponse({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type PostFeaturedLotsByCatalogIdParams = {
    authToken: string;
    catalogId: number;
    deployment: string;
    lotNumbers: string[];
};

export enum FeaturedLotsStatus {
    Created = 'created',
    Updated = 'updated',
}

export type PostFeaturedLotsByCatalogIdResponse = {
    error: boolean;
    payload: {
        featuredLots: string[];
        promotionId: number;
        status: FeaturedLotsStatus;
    };
};

export const postFeaturedLotsByCatalogId = ({
    authToken,
    catalogId,
    deployment,
    lotNumbers,
}: PostFeaturedLotsByCatalogIdParams) =>
    new Promise<PostFeaturedLotsByCatalogIdResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `featured-lots/${catalogId}`,
            authToken,
            deployment,
            path: '<PROMOTIONS-API>',
        });
        request.send({ lotNumbers });
        request.end((err, response) =>
            handleResponse({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type GetSuggestedFeaturedLotsParams = {
    authToken: string;
    catalogId: number;
    deployment: string;
};

export type GetSuggestedFeaturedLotsResponse = {
    data: SuggestedFeaturedLot[];
    message: string;
    success: boolean;
};

export const getSuggestedFeaturedLots = ({ authToken, catalogId, deployment }: GetSuggestedFeaturedLotsParams) =>
    new Promise<GetSuggestedFeaturedLotsResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `suggested-lots-to-feature/${catalogId}`,
            authToken,
            deployment,
            path: '<ITEM-API>',
        });
        request.end((err, response) =>
            handleResponse({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
